import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { UtilService } from '@services/util/util.service';
import { AMOUNT_FORM } from 'src/app/shared/models/amount.form';

@Component({
  selector: 'app-otp-input',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './otp-input.component.html',
  styleUrls: ['./otp-input.component.scss']
})
export class OtpInputComponent implements OnInit, OnDestroy {

  @Input() group: FormGroup;
  @Input() control: FormControl;
  @Input() customClass: string;
  @Input() boxType = false;
  @Input() autoFillOtp: string = '';
  @Output() otpEmit = new EventEmitter();
  @Output() onResendClick = new EventEmitter();
  @Output() onFocus = new EventEmitter();

  @ViewChild('otpInputField', { static: true }) otpInputField: ElementRef<HTMLInputElement>;

  errorMessage = AMOUNT_FORM.otp.error;
  showResend = false;
  timer = '';
  timerInterval: any;
  isMobile;
  otpControls = Array.from({ length: 6 }, () => new FormControl(''));
  @ViewChildren('otpInput') inputs!: QueryList<ElementRef>;

  constructor(
    public util: UtilService
  ) { }

  ngOnInit(): void {
    this.isMobile = this.util.isMobile();
    this.control.valueChanges.subscribe((val: string) => {
      if (val?.length > 6) {
        this.control.setValue(val.substring(0, 6));
      }
    });
    this.startTimer();
    if (this.boxType) {
      setTimeout(() => {
        this.focusInput(0);
      }, 10);
    }
  }

  ngOnChanges() {
    console.log('autoFillOtp: ', this.autoFillOtp);
    if (this.autoFillOtp && this.autoFillOtp?.length === 6) {
      this.fillOTP(this.autoFillOtp);
    }
  }

  onInput(event: Event, index: number) {
    const input = event.target as HTMLInputElement;
    const value = input.value;
    if (!/^\d$/.test(value)) {
      input.value = '';
      this.otpControls[index].setValue('');
      this.getOtp();
      return;
    }
    this.otpControls[index].setValue(value);
    this.getOtp();
    this.control.markAsTouched();
    this.control.updateValueAndValidity();
    if (value && index < 5) {
      this.focusInput(index + 1);
    }
  }

  focusInput(index: number) {
    const inputArray = this.inputs.toArray();
    const el = inputArray[index]?.nativeElement;
    if (el) {
      el.focus();
      setTimeout(() => {
        const length = el.value.length;
        el.setSelectionRange(length, length);
      }, 0);
    }
    this.onFocus.emit(index);
  }

  onKeyDown(event: KeyboardEvent, index: number) {
    const key = event.key;
    if (key === 'Backspace') {
      if (!this.otpControls[index].value && index > 0) {
        this.focusInput(index - 1);
      }
    } else if (key === 'ArrowLeft' && index > 0) {
      this.focusInput(index - 1);
    } else if (key === 'ArrowRight' && index < 5) {
      this.focusInput(index + 1);
    }
  }

  onPaste(e) {
    e.preventDefault();
    const pasteData = e.clipboardData?.getData('text/plain')?.trim() || '';
    const digits = pasteData.replace(/\D/g, '').substring(0, this.otpControls.length);
    this.fillOTP(digits);
  }

  fillOTP(digits: string) {
    for (let i = 0; i < digits.length; i++) {
      this.otpControls[i].setValue(digits[i]);
    }
    this.getOtp();
    const nextIndex = digits.length < this.otpControls.length ? digits.length : this.otpControls.length - 1;
    this.focusInput(nextIndex);
  }

  getOtp() {
    const otp = this.otpControls.map(ctrl => ctrl.value).join('');
    this.control.setValue(otp, { emitEvent: true });
    this.control.markAsTouched();
    this.control.updateValueAndValidity();
    return otp;
  }

  wrapClick() {
    this.otpInputField?.nativeElement?.focus();
  }

  startTimer() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
    this.showResend = false;
    let duration = 30; // 30 seconds
    this.timerInterval = setInterval(() => {
      let minutes = Math.floor(duration / 60);
      let seconds = duration % 60;
      this.timer = (minutes ? `${minutes}m ` : '') + (seconds ? `${seconds}s` : '');
      if (--duration < 0) {
        this.timer = '';
        this.showResend = true;
        clearInterval(this.timerInterval);
      }
    }, 1000);
  }

  resend() {
    this.control.setValue('');
    if (this.boxType) {
      this.otpControls.forEach(ctrl => ctrl.setValue(''));
      this.focusInput(0);
    }
    this.startTimer();
    this.onResendClick.emit(true);
  }

  ngOnDestroy(): void {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  }

}
